module.exports = __webpack_public_path__ + "static/media/slide (6).3267b195.jpg";